module.exports = __webpack_public_path__ + "img/features.1b550189.png";